import { Controller } from "@hotwired/stimulus";

// GR-3455: the AV tab on wizard step 6 of an externally sourced request.
//
// The tab is server-rendered and postable without any of this: every checkbox
// and every quantity box arrives with the state its saved row implies, and the
// session grid needs no script at all. What the browser adds is the one thing
// a static render cannot — keeping a quantity box in step with its checkbox as
// the checkbox is ticked, so an untouched quantity is never posted for an item
// nobody asked for.
export default class EventRequestAvNeedsController extends Controller {
  static targets = ["quantity", "counter", "checkbox"];

  // Ticking an item opens its quantity and offers 1, which is what the writer
  // would default it to anyway; unticking closes it again. Disabled rather
  // than hidden, so the row does not change height as boxes are ticked and the
  // quantity a saved item carries stays readable while it is off.
  toggleQuantity(event) {
    const checkbox = event.target;
    const quantity = this.quantityFor(checkbox.dataset.avKey);
    if (!quantity) return;

    quantity.disabled = !checkbox.checked;
    if (checkbox.checked && !quantity.value) quantity.value = "1";

    this.refreshCounter();
  }

  // The server rendered the count for the state the page arrived in, and a
  // count that disagrees with the boxes under it is worse than no count. Zero
  // hides rather than reading "0", which is how Primer renders it server-side.
  refreshCounter() {
    if (!this.hasCounterTarget) return;

    const ticked = this.checkboxTargets.filter((box) => box.checked).length;
    this.counterTarget.textContent = String(ticked);
    this.counterTarget.hidden = ticked === 0;
  }

  quantityFor(avKey) {
    return this.quantityTargets.find((input) => input.dataset.avKey === avKey);
  }
}
